import { useGlobalSharedState } from "./useSharedState";
import { ApiAuthUser } from "@incendium/api";
import { listAllUsers } from "features/users/services/userService";

export const useUsers = () => {
  const fetchUsers = async () => {
    const users = await listAllUsers();
    return users || [];
  };
  const { state, setState, refetch } = useGlobalSharedState<ApiAuthUser[]>(
    "users",
    [],
    fetchUsers
  );

  return {
    users: state,
    setUsers: setState,
    refetchUsers: refetch,
  };
};
